import { render, staticRenderFns } from "./PrizeUpdate.vue?vue&type=template&id=06119687&scoped=true"
import script from "./PrizeUpdate.vue?vue&type=script&lang=js"
export * from "./PrizeUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06119687",
  null
  
)

export default component.exports